import { createApi } from "@reduxjs/toolkit/query/react";
import { apiFetchBaseQuery } from "@/redux/apiFetchBaseQuery";

interface BillingReportResponse {
	summary: {
		total_revenue: number;
		total_orders: number;
		avg_revenue_per_order: number;
		last_period: {
			total_revenue: number;
			total_orders: number;
			change_percentage: number;
		};
		last_year: {
			total_revenue: number;
			total_orders: number;
			change_percentage: number;
		};
	};
	roll_up_summary: {
		charts: {
			client_revenue: Array<{
				agency_id: string;
				parent_agency_id: string;
				name: string;
				value: number;
				children: Array<{
					agency_id: string;
					parent_agency_id: string;
					name: string;
					prodata_net: number;
					order_count: number;
				}>;
			}>;
			client_campaign_count: Array<{
				agency_id: string;
				parent_agency_id: string;
				name: string;
				value: number;
				children: Array<{
					agency_id: string;
					parent_agency_id: string;
					name: string;
					prodata_net: number;
					order_count: number;
				}>;
			}>;
		};
	};
	charts: {
		client_revenue: Array<{ agency_id: string; parent_agency_id: string; name: string; value: number }>;
		client_campaign_count: Array<{ agency_id: string; parent_agency_id: string; name: string; value: number }>;
		eblast_vs_rtb: Array<{ name: string; value: number }>;
		revenue_by_sales_rep: Array<{ name: string; value: number }>;
		campaigns_by_day: Array<{ name: string; value: number }>;
		revenue_by_day: Array<{ name: string; value: number }>;
	};
}

export const billingReportSlice = createApi({
	reducerPath: "billingReportSlice",
	baseQuery: apiFetchBaseQuery,
	tagTypes: ["billingReport"],
	keepUnusedDataFor: 0,
	endpoints: builder => ({
		getBillingReport: builder.query({
			query: ({ startDate, endDate }: { startDate: string; endDate: string }) => ({
				url: `/reporting/financial`,
				method: "POST",
				body: {
					start_date: startDate,
					end_date: endDate,
				},
				headers: {
					"Content-Type": "application/json",
				},
				keepUnusedDataFor: 0,
			}),
			transformResponse: (response: { data: BillingReportResponse }) => {
				const { data } = response;
				return {
					summary: data.summary,
					rollUpSummary: {
						charts: {
							clientRevenue: data.roll_up_summary.charts.client_revenue || [],
							clientCampaignCount: data.roll_up_summary.charts.client_campaign_count || [],
						},
					},
					clientRevenue: data.charts.client_revenue || [],
					clientCampaignCount: data.charts.client_campaign_count || [],
					eblastVsRtb: data.charts.eblast_vs_rtb || [],
					revenueByRep: data.charts.revenue_by_sales_rep || [],
					campaignByDay: data.charts.campaigns_by_day || [],
					revenueByDay: data.charts.revenue_by_day || [],
				};
			},
		}),
	}),
});

export const { useGetBillingReportQuery } = billingReportSlice;
